import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAgent } from "../../api/apiAgents";
import parseError from "../../utils/parseError";

const useRestoreAgent = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAgentAction, isPending } = useMutation({
        mutationFn: restoreAgent,
        onSuccess: (res) => {
            const message = res?.message || "Agent restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore agent");
        },
    });

    return { restoreAgent: restoreAgentAction, isPending };
};

export default useRestoreAgent;
